import React from "react";
import ReactDOM from "react-dom";
import Main from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";
// import "antd/dist/antd.css";
import moment from 'moment';
import 'moment/locale/zh-cn';
import { Provider } from "react-redux";
import initStore from "./config/store";
const store = initStore();
moment.locale('zh-cn');
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename="/fe-pc/b/fe_fitness_user">
      <ConfigProvider locale={zhCN}>
        <Main />
      </ConfigProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
